<template>
  <div class="footer flex justify-center hide-for-print">
    <div class="flex flex-col justify-center items-center">
      <img
        class="w-[170px] h-[105px] mb-5"
        src="../../assets/images/footer/logo01.png"
        alt=""
      />
      <div class="flex mb-[60px]">
        <router-link
          target="_blank"
          :to="'/about'"
          class="baseClass cursor-pointer"
          >关于我们</router-link
        >
        <button class="baseClass cursor-pointer">加入我们</button>
        <!-- <router-link target="_blank" :to="'/join'" class="baseClass cursor-pointer">加入我们</router-link> -->
        <router-link
          target="_blank"
          :to="'/help'"
          class="baseClass cursor-pointer"
          >帮助中心</router-link
        >
        <router-link
          target="_blank"
          :to="'/agreement'"
          class="baseClass cursor-pointer"
          >网站协议</router-link
        >
      </div>
      <div class="flex mb-4" style="color: #737380">
        <router-link
          target="_blank"
          :to="'/certify'"
          class="cursor-pointer underline mr-10"
          >营业执照</router-link
        >
        <!-- <router-link target="_blank" :to="'/certifys'" class="cursor-pointer underline mr-10">增值电信业务经营许可证
          沪B2-20221073</router-link> -->
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
          class="cursor-pointer underline mr-10"
        >
          浙ICP备2025201608号‑1
        </a>
        <p class="">© {{ currentYear }} WidoFactory</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
const currentYear = ref(new Date().getFullYear());
</script>
<style scoped lang="scss">
.footer {
  min-height: 140px;
  width: 100%;
  background: #191924 linear-gradient(to right, #191924, #ffffff17);
  padding: 50px 0 44px 0;
  margin-top: 100px;
  text-align: center;

  //   & > div {
  //     width: 1200px;
  //   }
  .baseClass {
    font-size: 14px;
    color: #fff;
    width: 91px;
    padding-right: 20px;
    letter-spacing: 2px;
  }
}
</style>
